import React from "react";

import ResetPasswordForm from "../reset-password-form";
import { useAppSelector } from "src/redux/redux-hooks";

const ResetPasswordView: React.FC = () => {
  const { artifacts } = useAppSelector((state) => state.app);
  
  return (
    <section className="login-mn">
      <div className="log-logo m-b-20">
        <img
          src={artifacts?.logo}
          alt="Logo"
          style={{
            maxWidth: "250px",
            maxHeight: "100px",

            visibility: artifacts?.logo ? "visible" : "hidden",
            minHeight: "60px",
          }}
        />
      </div>
      <div className="log-fld">
        <h2 className="text-center">Change Password</h2>
        <ResetPasswordForm />
      </div>
    </section>
  );
};

export default ResetPasswordView;
